export default (
  singular,
  { minW, maxW, minH, maxH },
  { tooSmall, tooLarge },
) => ({
  widthError: null,
  heightError: null,

  update() {
    if (singular) this.$refs.height.value = this.$refs.width.value
  },

  validate() {
    this.update()
    const isValid = this.valid()
    this.$dispatch('validate', { isValid })
    if (!isValid) this.reportErrors()

    return isValid
  },

  submit(form) {
    if (!this.validate()) return

    this.$store.modal.confirm()
    setTimeout(() => document.querySelector(form).requestSubmit(), 10)
  },

  visit(url) {
    if (!this.validate()) return

    const href = this.customFormatUrl(url)
    this.$store.modal.confirm()
    setTimeout(() => Turbo.visit(href), 10)
  },

  sanitize() {
    this.widthError = null
    this.heightError = null
    this.$el.value = this.$el.value.replace(/\D/g, '')
  },

  neutralize() {
    const side = this.$el.name

    if (!this[side + 'Error']) return

    this[side + 'Error'] = null
    this.$el.value = this.$el.dataset.initial
  },

  valid() {
    const [w, h] = this.values()
    return (
      (w >= minW && w <= maxW && h >= minH && h <= maxH) ||
      (w >= minH && w <= maxH && h >= minW && h <= maxW)
    )
  },

  reportErrors() {
    const [w, h] = this.values()

    if (singular) {
      const [error] = this.violation(
        w,
        Math.max(minW, minH),
        Math.min(maxW, maxH),
      )
      this.widthError = error
      return
    }

    const wRange = this.fixableRange(h)
    const hRange = this.fixableRange(w)

    if (wRange && hRange) this.flagCloser(w, h, wRange, hRange)
    else if (wRange) this.widthError = this.violation(w, ...wRange)[0]
    else if (hRange) this.heightError = this.violation(h, ...hRange)[0]
    else this.flagBoth(w, h)
  },

  fixableRange(other) {
    const ranges = []
    if (other >= minW && other <= maxW) ranges.push([minH, maxH])
    if (other >= minH && other <= maxH) ranges.push([minW, maxW])
    if (ranges.length === 0) return null
    return [
      Math.min(...ranges.map((r) => r[0])),
      Math.max(...ranges.map((r) => r[1])),
    ]
  },

  flagCloser(w, h, wRange, hRange) {
    const [wErr, wDev] = this.violation(w, ...wRange)
    const [hErr, hDev] = this.violation(h, ...hRange)
    if (wDev <= hDev) this.widthError = wErr
    else this.heightError = hErr
  },

  flagBoth(w, h) {
    const min = Math.max(minW, minH)
    const max = Math.min(maxW, maxH)
    const [wErr, wDev] = this.violation(w, min, max)
    const [hErr, hDev] = this.violation(h, min, max)
    const sameDirection = (w < min && h < min) || (w > max && h > max)
    if (sameDirection) {
      this.widthError = wErr
      this.heightError = hErr
    } else if (wDev <= hDev) {
      this.widthError = wErr
    } else {
      this.heightError = hErr
    }
  },

  violation(value, min, max) {
    if (value < min) return [interpolate(tooSmall, min), min - value]
    if (value > max) return [interpolate(tooLarge, max), value - max]
    return [null, 0]
  },

  values() {
    return [
      parseInt(this.$refs.width.value) || 0,
      parseInt(this.$refs.height.value) || 0,
    ]
  },

  customFormatUrl(baseUrl) {
    return baseUrl.replace(
      /CUSTOM_X_Y/,
      `custom_${this.$refs.width.value}x${this.$refs.height.value}`,
    )
  },
})

function interpolate(message, value) {
  return message.replace(/%{size}/g, value)
}
